<h1>
    Welcome to the Angular Fundamentals Git Search!
  </h1>
  <nav>
    <a routerLink="/search-repo" routerLinkActive="active">
      <button>Search For Repositories</button>
    </a>
    <a routerLink="/search-user" routerLinkActive="active">
        <button>Search For Users</button>
      </a>
  </nav>